export default "__VITE_ASSET__71f7ffb4__"